import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';
export var CardHeader = function (props) {
    return (React.createElement("div", { style: props.style, className: classNames('k-card-header', props.className) }, props.children));
};
CardHeader.propTypes = {
    className: PropTypes.string
};
//# sourceMappingURL=CardHeader.js.map